import { render } from "./Timer.vue?vue&type=template&id=138e4a98&scoped=true&bindings={}"
import script from "./Timer.vue?vue&type=script&lang=ts"
export * from "./Timer.vue?vue&type=script&lang=ts"

import "./Timer.vue?vue&type=style&index=0&id=138e4a98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-138e4a98"

export default script